import * as React from 'react';
import ServiceSummaryDivider from '../components/ServiceSummaryDivider/ServiceSummaryDivider';
import ServiceSummaryOption from '../components/ServiceSummaryOption';
const LoyaltySummary = props => {
    return (React.createElement(ServiceSummaryDivider, null, props.options.map(option => (React.createElement(ServiceSummaryOption, { groupOption: {
            header: option.header,
            items: option.items
        } })))));
};
export default LoyaltySummary;
